(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/behaviors/navigation.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/behaviors/navigation.js');

'use strict';

const {
  Events
} = svs.accountservices.authenticate.definitions;
svs.player_login.behaviors.Navigation = Marionette.Behavior.extend({
  ui: {
    linkButton: '.js-login-navigation',
    linkCancelButton: '.js-login-navigation-cancel',
    blockableLink: '.js-login-navigation-blockable'
  },
  events: {
    'click @ui.linkButton': 'onNavigationClick',
    'click @ui.linkCancelButton': 'onNavigationCancelClick'
  },
  initialize() {
    this.navigationBlocked = false;
  },
  onBlockNavigation() {
    this.navigationBlocked = true;
    this.getUI('blockableLink').prop('disabled', true);
  },
  onUnblockNavigation() {
    this.navigationBlocked = false;
    this.getUI('blockableLink').prop('disabled', false);
  },
  onDoNavigation() {
    let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
    let external = arguments.length > 1 ? arguments[1] : undefined;
    if (!external && svs.player_login.router.hasRoute(target)) {
      svs.player_login.router.navigate("".concat(target, "?").concat(this.view.model.toQueryString()), true);
    } else {
      svs.utils.url.navigate(target);
    }
  },
  onNavigationClick(e) {
    e.preventDefault();
    if (e.currentTarget.dataset.url && !this.navigationBlocked) {
      this.onDoNavigation(e.currentTarget.dataset.url, e.currentTarget.dataset.external === 'true');
    }
  },
  onNavigationCancelClick(e) {
    e.preventDefault();
    if (e.currentTarget.dataset.url && !this.navigationBlocked) {
      if (svs.accountservices.authenticate.login.isStarted()) {
        this.onBlockNavigation();
        this.cancelListener = () => this.onCancel(e);
        svs.accountservices.authenticate.login.on(Events.CANCELLED, this.cancelListener, this);
        svs.accountservices.authenticate.login.cancel();
      } else {
        this.onNavigationClick(e);
      }
    }
  },
  onCancel(e) {
    this.onDoNavigation(e.currentTarget.dataset.url, !!e.currentTarget.dataset.external);
  },
  onDestroy() {
    if (this.cancelListener) {
      svs.accountservices.authenticate.login.off(Events.CANCELLED, this.cancelListener);
    }
  }
});

 })(window);